module.exports = __webpack_public_path__ + "media/components/Sponsors/Projects/Show/PostReport/caution-0e040306793f5131a7029b5ffa1c5303.png";